import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { currentDataMode } from "@/data/mode";
import { loadDataSource } from "@/data/load";
import { BootError } from "@/components/chrome/BootError";
import "./index.css";

// pdf.js 4.x calls Promise.withResolvers, which iOS Safari added in 17.4.
if (typeof (Promise as unknown as { withResolvers?: unknown }).withResolvers !== "function") {
  (Promise as unknown as { withResolvers: <T>() => { promise: Promise<T>; resolve: (v: T | PromiseLike<T>) => void; reject: (r?: unknown) => void } }).withResolvers = <T,>() => {
    let resolve!: (v: T | PromiseLike<T>) => void;
    let reject!: (r?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}

const root = createRoot(document.getElementById("root")!);
const mode = currentDataMode();
document.documentElement.dataset.dataMode = mode;

loadDataSource(mode)
  .then((source) => {
    root.render(
      <StrictMode>
        <App source={source} />
      </StrictMode>,
    );
  })
  .catch((error: unknown) => {
    console.error(error);
    root.render(<BootError />);
  });
